// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_hello-pangea_dnd_dist_dnd_esm_js-node_modules_lucide-react_dist_esm_icon-354483":"245a762c","src_pages_home_children_pricing_Pricing_tsx":"2e114f92"}[chunkId] + ".chunk.css";
};